export default __webpack_public_path__ + "static/O0198-0bebd118e183058a23478a66472f7f36.png";